<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="120px" label-position="left">
            <el-row>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="subsidyType" label="补贴类型" prop="subsidyType" :rules="$rules.changeIred">
                  <el-select v-model="form.subsidyType" placeholder="请选择" @change="changeSubsidyType" class="w100b" :disabled="disable">
                    <el-option v-for="item in subsidyTypeColumns" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="dataMonth" label="选择月份" prop="dataMonth" :rules="$rules.changeIred">
                  <el-date-picker v-model="form.dataMonth" type="month" placeholder="选择月" :clearable="false" class="w100b" value-format="yyyy-MM" @change="changeMonth" :disabled="disable"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="staffId" label="店员姓名" prop="staffId" :rules="$rules.changeIred">
                  <el-select v-model="form.staffId" clearable placeholder="请选择" @change="onStaffName" class="w100b" :disabled="!userInfo.superManage || disable">
                    <el-option v-for="item in staffList" :key="item.id" :label="item.staffName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form.subsidyType == 'socialReimburse'"> 
                <el-form-item class="el-form-item-update" ref="shopId" label="报销门店" prop="shopId" :rules="$rules.changeIred">
                  <el-select v-model="form.shopId" clearable placeholder="请选择" class="w100b">
                    <el-option v-for="item in shopList" :key="item.id" :label="item.shopName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form.subsidyType == 'coverall' || form.subsidyType == 'bedding'">
                <el-form-item class="el-form-item-update" ref="coverallAndBedding" label="类型" prop="coverallAndBedding" :rules="$rules.changeIred">
                  <el-select v-model="form.coverallAndBedding" clearable placeholder="请选择" @change="onCoverallAndBedding" class="w100b">
                    <el-option v-for="item in clothingColumns" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form.subsidyType == 'openCleanSubsidy'">
                <el-form-item class="el-form-item-update" ref="beginDate" label="开始时间" prop="beginDate" :rules="$rules.changeIred">
                  <el-date-picker v-model="form.beginDate" type="date" :picker-options="beginPickerOptions" :readonly="form.dataMonth ? false:true" placeholder="开始时间" @change="onDate('start')" class="w100b"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form.subsidyType == 'openCleanSubsidy'">
                <el-form-item class="el-form-item-update" ref="endDate" label="结束时间" prop="endDate" :rules="$rules.changeIred">
                  <el-date-picker v-model="form.endDate" type="date" :picker-options="beginPickerOptions" :readonly="form.dataMonth ? false:true" placeholder="结束时间" @change="onDate('end')" class="w100b"></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="12" v-if="form.subsidyType == 'coverall'">
                <el-form-item class="el-form-item-update" ref="subsidyType" label="报销套数" prop="subsidyType" :rules="$rules.changeIred">
                  <el-radio-group v-model="form.reimburseTotal" @change="onChangeReimburseTotal">
                    <el-radio :label="1">1套</el-radio>
                    <el-radio :label="2">2套</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :span="12" v-if="form.subsidyType == 'openCleanSubsidy' || form.subsidyType == 'coverall'">
                <el-form-item class="el-form-item-update" label="金额（元）" prop="applyAmount">
                  <el-input v-model="form.applyAmount" disabled placeholder="请输入金额"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-else>
                <el-form-item class="el-form-item-update" ref="applyAmount" label="金额（元）" prop="applyAmount" :rules="$rules.money">
                  <el-input v-model="form.applyAmount" placeholder="请输入金额"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form.subsidyType == 'fare'">
                <el-form-item class="el-form-item-update" ref="vehicle" label="交通工具" prop="vehicle" :rules="$rules.changeIred">
                  <el-select v-model="form.vehicle" clearable placeholder="请选择" class="w100b">
                    <el-option v-for="item in vehicleColumns" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>  
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form.subsidyType == 'fare'">
                <el-form-item class="el-form-item-update" ref="trip" label="行程" prop="trip" :rules="$rules.changeIred">
                  <el-select v-model="form.trip" clearable placeholder="请选择" class="w100b">
                    <el-option v-for="item in tripColumns" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>  
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form.subsidyType == 'fare'">
                <el-form-item class="el-form-item-update" ref="startStationFormItem" label="起始站" prop="startStationValueList" :rules="$rules.required">
                  <el-cascader
                    ref="startStationCascader"
                    v-model="form.startStationValueList"
                    :options="provinceCityOptions"
                    placeholder="请选择起始站"
                    class="w100b"
                    clearable
                    @change="handleStartStationChange">
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form.subsidyType == 'fare'">
                <el-form-item class="el-form-item-update" ref="endStationFormItem" label="终点站" prop="endStationValueList" :rules="$rules.required">
                  <el-cascader
                    ref="endStationCascader"
                    v-model="form.endStationValueList"
                    :options="provinceCityOptions"
                    placeholder="请选择终点站"
                    class="w100b"
                    clearable
                    @change="handleEndStationChange">
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item class="el-form-item-update" ref="remark" label="备注" prop="remark">
                  <el-input v-model="form.remark" type="textarea" placeholder="请输入备注" maxlength="150"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="isShowProofUrl">
              <p class="order-title-boxs"><span class="blueBlock"></span><i>凭证</i></p>
              <div class="pl24"><imgUpload @file="getFile" :imgHide="imgHide" :fileList="form.imgUrlList" @delete="handleDelete" module="subsidyCertificate"></imgUpload></div>
            </div>
            <p class="order-title-boxs" v-if="form.subsidyType == 'cashier' || form.subsidyType == 'viceShopManager'"><span class="blueBlock"></span><i>补贴明细</i></p>
            <div class="totals-box customTable" v-if="form.subsidyType == 'cashier' || form.subsidyType == 'viceShopManager'">
              <div class="detail plr20">
                <el-table :data="subsidyDetail" input-large header-cell-class-name="table_header_bgcolor" show-summary :summary-method="getSummaries">
                  <el-table-column label="日期" width="auto">
                    <template slot-scope="scope">{{ formatDay(scope.row.subsidyDate)}}</template>
                  </el-table-column>
                  <el-table-column prop="attendanceFlagCn" label="是否出勤（含公休）" width="auto"></el-table-column>
                  <el-table-column prop="staffNumber" label="在店人数" width="auto"></el-table-column>
                  <el-table-column prop="applyAmount" label="补贴金额" width="auto">
                      <template slot-scope="scope">
                        {{scope.row.applyAmount}}
                      </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="foot-msg padding-no" v-if="remarkList.length > 0">
              <p class="infos">申请规则:</p>
              <p v-for="item,index in remarkList" :key="index">{{item}}</p>
            </div>  
          </el-form>
          <div class="drawer-footer pr24 pb10">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="save">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import imgUpload from "../../../components/common/modules/upload";
import areaData from "../../../assets/javascript/area.js";
export default {
  mixins: [minxin],
  components: {
    drawer,
    imgUpload
  },
  data () {
    return {
      addEditShow: false,
      addEditTitle: "新增补贴",
      dialogHide: false,
      form: {
        salaryModuleType: "subsidySalary",
        dataMonth: '',
        subsidyType: "",
        beginDate: "",
        endDate: "",
        staffId: "",
        staffName: "",
        applyAmount: "",
        vehicle: null,
        trip: null,
        startStationValueList: [],
        startStationLabelList: [],
        endStationValueList: [],
        endStationLabelList: [],
        remark: "",
        imgUrlList: [],
        subsidyInfoItemList: []
      },
      imgHide: true,
      subsidyTypeColumns: [
      // {
      //   label: "收银补贴",
      //   value: "cashier"
      // },
      {
        label: "厨师补贴",
        value: "chef"
      }, {
        label: "车费补贴",
        value: "fare"
      }, {
        label: "体检补贴",
        value: "healthCheck"
      }],
      vehicleColumns: [{
        label: "汽车",
        value: "car"
      }, {
        label: "火车硬座",
        value: "trainHardSeat"
      }, {
        label: "火车硬卧",
        value: "trainHardSleeper"
      }, {
        label: "高铁",
        value: "train"
      }, {
        label: "飞机",
        value: "plane"
      }],
      tripColumns: [{
        label: "单趟",
        value: "oneWay"
      }, {
        label: "往返",
        value: "returnJourney"
      }],
      clothingColumns: [],
      staffList: [],
      subsidyDetail: [],
      isShowProofUrl: false,
      userInfo: {
        shopBizConfig: {

        }
      },
      maxAmount: 0,
      provinceCityOptions: [],
      remarkList: [],
      configList: [],
      shopList: [],
      disable: false
    };
  },
  created() {
    this.init();
  },
  computed: {
    beginPickerOptions () {
      return {
        disabledDate: (time) => {
          return this.dealDisabledDate(time)
        },
      }
    }
  },
  methods: {
    initProvinceCityData() {
      const provinceList = areaData.province_list;
      const cityList = areaData.city_list;
      
      const options = [];
      
      for (const provinceCode in provinceList) {
        const provinceItem = {
          value: provinceCode,
          label: provinceList[provinceCode],
          children: []
        };
        
        const provincePrefix = provinceCode.substring(0, 2);
        for (const cityCode in cityList) {
          const cityPrefix = cityCode.substring(0, 2);
          if (cityPrefix === provincePrefix) {
            provinceItem.children.push({
              value: cityCode,
              label: cityList[cityCode]
            });
          }
        }
        
        if (provinceItem.children.length > 0) {
          options.push(provinceItem);
        }
      }
      
      this.provinceCityOptions = options;
      console.log('省市数据初始化完成，共', options, '个省份');
    },
    handleStartStationChange(value) {
      if (!value || value.length === 0) {
        this.form.startStationLabelList = [];
        return;
      }
      
      const nodes = this.$refs.startStationCascader.getCheckedNodes();
      if (nodes && nodes.length > 0) {
        const node = nodes[0];
        const labels = node.pathLabels;
        this.form.startStationLabelList = labels;
        
        console.log('起始站选择:', {
          value: value,
          labels: labels,
          text: this.form.startStationLabelList,
          province: {
            code: value[0],
            name: labels[0]
          },
          city: {
            code: value[1],
            name: labels[1]
          }
        });
      }
    },
    handleEndStationChange(value) {
      if (!value || value.length === 0) {
        this.form.endStationLabelList = [];
        return;
      }
      
      const nodes = this.$refs.endStationCascader.getCheckedNodes();
      if (nodes && nodes.length > 0) {
        const node = nodes[0];
        const labels = node.pathLabels;
        this.form.endStationLabelList = labels;
        
        console.log('终点站选择:', {
          value: value,
          labels: labels,
          text: this.form.endStationLabelList,
          province: {
            code: value[0],
            name: labels[0]
          },
          city: {
            code: value[1],
            name: labels[1]
          }
        });
      }
    },
    getStationInfo(stationValue, stationText) {
      if (!stationValue || stationValue.length === 0) {
        return null;
      }
      
      return {
        provinceCode: stationValue[0],
        provinceName: stationText ? stationText.split(' - ')[0] : '',
        cityCode: stationValue[1],
        cityName: stationText ? stationText.split(' - ')[1] : '',
        fullText: stationText,
        fullValue: stationValue
      };
    },
    //  页面初始化函数
    dealDisabledDate (time) {
      let {monthStartDate,monthEndDate} = this.getStartDay(this.form.dataMonth);
      let endValue = "";
      if (this.formatMonth(new Date()) == this.form.dataMonth) {
        endValue = this.formatDay(new Date());
      } else {
        endValue = monthEndDate;
      }
      return (
        time.getTime() + 8.64e7 < new Date(monthStartDate).getTime() || time.getTime() >= new Date(endValue).getTime()
      )
    },
    init() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data())
        this.addEditShow = true;
        this.userInfo = this.$store.getters.ShopInfo;
        console.log(this.userInfo);
        this.form = {
          salaryModuleType: "subsidySalary",
          dataMonth: '',
          subsidyType: "",
          beginDate: "",
          endDate: "",
          staffId: "",
          staffName: "",
          shopId: '',
          applyAmount: "",
          vehicle: null,
          trip: null,
          startStationValueList: [],
          startStationLabelList: [],
          endStationValueList: [],
          endStationLabelList: [],
          remark: "",
          imgUrlList: [],
          subsidyInfoItemList: []
        }
        this.shopList = [];
        if (org) {
          this.form.subsidyType = org.subsidyType;
          this.form.subsidyTypeCn = org.subsidyTypeCn;
          this.form.dataMonth = this.formatMonth(new Date());
          this.form.staffId = org.staffId;
          this.form.staffName = org.staffName;
          this.disable = true;
          this.setClothingColumns();
          this.getBySubsidyType();
        }
        this.initProvinceCityData();
        if (this.userInfo.superManage) {
          this.subsidyTypeColumns = [
            // {
            //   label: "收银补贴",
            //   value: "cashier"
            // }, 
            // {
            //   label: "副店长补贴",
            //   value: "viceShopManager"
            // },
            {
              label: "车费补贴",
              value: "fare"
            }, {
              label: "体检补贴",
              value: "healthCheck"
            },{
              label: "工服补贴",
              value: "coverall"
            },{
              label: "床品补贴",
              value: "bedding"
            },{
              label: "开业打扫补贴",
              value: "openCleanSubsidy"
            },
            {
              label: "综合补贴",
              value: "socialReimburse"
            },
          ]
        } else {
          if (!org) {
            this.form.staffId = this.userInfo.staffId;
            this.form.staffName = this.userInfo.staffName;
          }
          this.subsidyTypeColumns = [
            {
              label: "车费补贴",
              value: "fare"
            }, {
              label: "体检补贴",
              value: "healthCheck"
            },{
              label: "工服补贴",
              value: "coverall"
            },{
              label: "床品补贴",
              value: "bedding"
            },{
              label: "综合补贴",
              value: "socialReimburse"
            },]
        }
        
        this.getStaffList();
      });
    },
    onDataMonth () {
      if (!this.form.dataMonth) {
        return this.$message.error("请选择月份")
      }
    },
    changeMonth (value) {
      this.form.beginDate = "";
      this.form.endDate = "";
      console.log(this.form.dataMonth);
      if (value && this.form.subsidyType) {
        this.onSubsidyType(this.form.subsidyType)
      }
      this.shopList = [];
      if (this.form.staffId && this.form.subsidyType == "socialReimburse") {
        this.form.shopId = '';
        this.getShopList();
      }
    },
    changeSubsidyType (value) {
      if (this.form.dataMonth && value) {
        this.onSubsidyType(value)
      }
    },
    onSubsidyType (value) {
      console.log(value);
      this.form = {
        salaryModuleType: 'subsidySalary',
        dataMonth: this.form.dataMonth,
        subsidyType: value,
        beginDate: '',
        subsidyInfoItemList: [],
        endDate: '',
        staffId: this.userInfo.staffId,
        staffNo: '',
        staffName: this.userInfo.staffName,
        shopId: '',
        applyAmount: '',
        vehicle: null,
        trip: null,
        startStationValueList: [],
        startStationLabelList: [],
        endStationValueList: [],
        endStationLabelList: [],
        proofUrl: '',
        remark: '',
        imgUrlList: [],
        subsidyInfoItemList: []
      };
      this.shopList = [];
      this.setClothingColumns();
      this.getBySubsidyType();
    },
    setClothingColumns () {
      if (this.form.subsidyType == 'coverall') {
          this.clothingColumns = [{
            label: "夏装",
            value: "summerWear"
          },{
            label: "冬装",
            value: "winterWear"
          }];
        } else if (this.form.subsidyType == 'bedding') {
          this.clothingColumns = [{
            label: "夏季床品",
            value: "summerBedding"
          },{
            label: "冬季床品",
            value: "winterBedding"
          },{
            label: "其他床品",
            value: "otherBedding"
          }];
        }
    },
    getBySubsidyType () {
      this.$api.get(this.$url.subsidySet.getBySubsidyType, {
        salaryModuleType: this.form.salaryModuleType,
        subsidyType: this.form.subsidyType,
        dataMonth: this.form.dataMonth
      }).then(res => {
        if (res) {
          this.maxAmount = res.maxAmount;
          this.isShowProofUrl = false;
          this.configList = res.configList;
          if (res.uploadProofFlag == 'enable') {
            this.isShowProofUrl = true;
          } else {
            this.form.imgUrlList = [];
          }
          this.subsidyDetail = [];
          this.remarkList = res.remarkList || []
        }
      });
    },
    getStaffList () {
      this.$api.get(this.$url.companyStaff.list).then(res => {
        if (res) this.staffList = res;
      })
    },
    onStaffName () {
      this.staffList.map(item => {
        if (item.id == this.form.staffId) this.form.staffName = item.staffName;
      })
      if ((this.form.subsidyType == 'cashier' || this.form.subsidyType == 'viceShopManager') && this.form.beginDate && this.form.endDate && this.form.staffId) {
        this.$api.post(this.$url.subsidySet.listSubsidyItemByDate, {
          beginTime: this.formatDay(this.form.beginDate),
          endTime: this.formatDay(this.form.endDate),
          salaryModuleType: this.form.salaryModuleType,
          subsidyType: this.form.subsidyType,
          dataMonth: this.form.dataMonth,
          staffId: this.form.staffId
        }).then(res => {
          if (res) {
            this.subsidyDetail = res.detailList;
            this.form.subsidyInfoItemList = res.detailList;
            this.form.applyAmount = res.subsidySumAmount;
          }
        })
      }
      if (this.form.dataMonth && this.form.subsidyType == "socialReimburse") {
        this.shopList = [];
        this.form.shopId = '';
        this.getShopList();
      }
    },
    getShopList () {
      this.$api.get(this.$url.subsidyApply.staffShopList, {staffId: this.form.staffId, dataMonth: this.form.dataMonth}).then(res => {
        if (res) this.shopList = res;
      })
    },
    onCoverallAndBedding () {
      this.clothingColumns.map(item => {
        if (item.value == this.form.coverallAndBedding) {
          this.form.clothingName = item.label;
          if (this.form.subsidyType == 'coverall') {
            this.form.coverallType = item.value;
            if (this.form.reimburseTotal) this.calculation(this.form.reimburseTotal, this.form.coverallType)
          } else if (this.form.subsidyType == 'bedding') {
            this.form.beddingType = item.value;
          }
        }
      })
    },
    onChangeReimburseTotal (val) {
      if (this.form.coverallType) {
        this.calculation(val, this.form.coverallType)
      }
    },
    calculation (num, type) {
      let result = this.configList.find(item => item.goodsType == type)
      this.form.applyAmount = num * result.maxAmount;
    },
    getFile(res) {
      this.form.imgUrlList.push(res);
      if (this.form.imgUrlList.length >= 5) {
          this.imgHide = false;
      }
    },
    handleDelete(res) {
      this.form.imgUrlList = res;
      if (this.form.imgUrlList.length < 5) {
          this.imgHide = true;
      }
    },
    onDate (type) {
      if (type == 'start' && this.form.dataMonth != this.formatMonth(this.form.beginDate)) {
        this.form.beginDate = "";
        return this.$message.error("请选择选定月份的日期");
      } else if (type == 'end' && this.form.dataMonth != this.formatMonth(this.form.endDate)) {
        this.form.endDate = "";
        return this.$message.error("请选择选定月份的日期");
      }
      if (this.form.beginDate && this.form.endDate && new Date(this.form.beginDate).getTime() > new Date(this.form.endDate).getTime()) {
        this.form.endDate = "";
        return this.$message.error("结束时间不能小于开始时间");
      }
      if (this.form.subsidyType == 'openCleanSubsidy' && this.form.beginDate && this.form.endDate) {
        let num = this.datedifference(this.form.beginDate, this.form.endDate);
        console.log(num);
        this.form.applyAmount = (Number(this.maxAmount) * (num + 1)).toFixed(2);
      }
    },
    save() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.form.beginDate = this.formatDay(this.form.beginDate);
          this.form.endDate = this.formatDay(this.form.endDate);
          if (this.form.imgUrlList.length === 0 && this.isShowProofUrl) {
            return this.$message.error("请上传凭证");
          } else if (this.form.applyAmount == 0) {
            return this.$message.error("金额不能为0")
          }
          if (this.form.subsidyType == 'chef') {
            this.form.subsidyInfoItemList = this.subsidyDetail;
          }
          
          this.$api.post(this.$url.subsidyApply.save, this.form).then(res => {
            if (res) {
              this.$api.success();
              this.addEditShow = false;
              this.$emit("change", true);
            }
          })
        }
      });
    },
    back ( ) {
      this.addEditShow = false;
      this.$refs.form.resetFields();
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index == columns.length - 1) {
          const values = data.map(item => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      if (sums[3]) sums[3] = sums[3].toFixed(2);
      return sums;
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.totalAmount {
  font-size: 18px;
  font-weight: bold;
  color: #111;
  margin: 20px 0 0 0;
  .totalAmount_title {
    display: inline-block;
    width: 120px;
    min-width: 100px;
    padding-left: 24px;
    margin-right: 80px;
  }
}
.foot-msg {
  background: #FBFBFC;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  margin: 20px 24px 0;
  color: #999;
  p {
    margin-bottom: 10px;
  }
  .infos {
    color: #ff892a;
    margin-bottom: 20px;
  }
}
.padding-no {
  padding: 10px 20px 0;
}
</style>